import { Dict } from 'mixpanel-browser'
import { getEnv, types } from 'mobx-state-tree'

import { getRootStore } from '#state/models/getRootStore'
import { ScrapiClient } from '#util'
import {
  MixpanelEventLinkClickedData,
  MixpanelEventName,
} from '#util/mixpanel/eventNames'

import type { Environment } from '../types'

// The base model adds shared environment, logging, and analytics helpers.
export const BaseModel = types
  .model('Base', {})
  .views((self) => ({
    get environment(): Environment {
      return getEnv(self)
    },
    get apiClient(): Environment['apiClient'] {
      return this.environment.apiClient
    },
    get scrapi(): ScrapiClient {
      return getRootStore(self).scrapiClient
    },
    get analytics() {
      return this.environment.analytics
    },
    /*
      All mst model instances now have log.debug, log.warn, etc.
      And since the mst root has it you can do:

      const { log } = useMst()
      log.info('This is a log message', { details: 'boop' })
    */
    get log() {
      const { debug, info, warn, error, warnOnce, errorOnce } =
        this.environment.datadog
      return {
        debug,
        info,
        warn,
        error,
        warnOnce,
        errorOnce,
      }
    },
  }))
  .actions((self) => ({
    trackEvent(eventName: MixpanelEventName, eventProperties?: Dict) {
      // on every event, we log some standard properties. These are properties
      // on the event, not user properties.
      const standardProps: Dict = {}
      const { currentOrg, currentScript } = getRootStore(self)

      if (currentOrg) {
        standardProps.orgId = currentOrg.id
      }

      if (currentScript) {
        standardProps.scriptId = currentScript.id
      }

      getRootStore(self).environment.analytics.track(eventName, {
        ...standardProps,
        ...eventProperties,
      })
    },
    trackLinkClicked(data: MixpanelEventLinkClickedData) {
      this.trackEvent('LINK_CLICKED', data)
    },
  }))
